export default __webpack_public_path__ + "static/media/mangaKent.0acebe88.png";